"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{FieldGroup as r}from"./src/FieldGroup.js";e("sp-field-group",r);
//# sourceMappingURL=sp-field-group.js.map
